<template>
  <h2 class="content-block">Groups</h2>
  <div v-if="loading" class="loading-overlay">
    LOADING...
    <span class="loader"></span>
  </div>
  <div v-else>

  <DxDataGrid class="dx-card wide-card" :data-source="groups" :key-expr="groupId" :selection="{ mode: 'single' }"
    :show-borders="true" :columns-auto-width="true" :column-min-width="50" :hover-state-enabled="true"
    :filter-builder="filterBuilder" :filter-value="filterValue" :column-resizing-mode="nextColumn"
    :allow-column-resizing="true" style="max-height: 80vh" @selection-changed="onSelectionChanged"
    @initialized="saveGridInstance" @exporting="onExporting">
    <DxLoadPanel :enabled="true" />
    <DxColumnChooser :enabled="true" mode="select" />
    <DxFilterRow :visible="true" />
    <DxHeaderFilter :visible="true" />
    <DxScrolling mode="virtual" />
    <DxExport :enabled="true" />
    <DxToolbar>
      <DxItem location="before" template="addRecordTemplate" />
      <DxItem location="after" template="refreshRecordTemplate" />
      <DxItem location="after" template="removeFilterRecordTemplate" />
      <DxItem location="after" name="exportButton" />
      <DxItem location="after" name="columnChooserButton" />
    </DxToolbar>

    <template #addRecordTemplate>
      <DxButton icon="add" @click="newRec" />
    </template>
    <template #refreshRecordTemplate>
      <DxButton icon="refresh" @click="refreshData" />
    </template>
    <template #removeFilterRecordTemplate>
      <DxButton icon="filter" @click="removeFilter" />
    </template>

    <DxColumn data-field="groupName" caption="Group Name" />
    <DxColumn data-field="active" caption="Active?" />
    <!-- <DxColumn caption="Commands" cell-template="cmdTemplate" /> -->

    <!-- <template #cmdTemplate>
      <DxButton class="list-icon" icon="group" @click="gotoGroupInfo" hint="Group Info"/>
      <DxButton class="list-icon" icon="globe" @click="gotoGroupPermArea" hint="Area Permissions"/>
      <DxButton class="list-icon" icon="checklist" @click="gotoGroupPermOper" hint="Operator Permissions"/>
    </template> -->
  </DxDataGrid>
  </div>
</template>

<script>
import {
  DxDataGrid,
  DxColumn,
  DxHeaderFilter,
  DxFilterRow,
  DxScrolling,
  DxColumnChooser,
  DxLoadPanel,
  DxToolbar,
  DxItem,
  DxExport
} from "devextreme-vue/data-grid";

import { DxButton } from 'devextreme-vue/button';

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxHeaderFilter,
    DxFilterRow,
    DxScrolling,
    DxColumnChooser,
    DxLoadPanel,
    DxButton,
    DxToolbar,
    DxItem,
    DxExport
  },
  created() {
    this.loadPageData();
  },
  data() {
    return {
      loading: true,
      dataGridInstance: null,
      selectedItemKeys: null,
      groups: []
    };
  },
  computed: {
    // groups() {
    //   return this.$store.getters["groups/getGroups"];
    // },
  },
  methods: {
    saveGridInstance: function (e) {
      this.dataGridInstance = e.component;
    },
    newRec() {
      this.$router.push({ name: 'group-details', params: { id: 0 } });
    },
    removeFilter() {
      this.dataGridInstance.clearFilter("row");
    },
    refreshData() {
      this.loadPageData();
    },
    onSelectionChanged({ selectedRowsData }) {
      this.$router.push({ name: 'group-details', params: { id: selectedRowsData[0].groupId } });
    },
    // onSelectionChanged(e) {
    //   this.selectedItemKeys = e.selectedRowsData[0].groupId;
    // },
    // gotoGroupInfo() {
    //   this.$router.push({ name: 'group-details', params: {id: this.selectedItemKeys }});
    // },
    // gotoGroupPermArea() {
    //   this.$router.push({ name: 'group-perm-area', params: {id: this.selectedItemKeys }});
    // },
    // gotoGroupPermOper() {
    //   this.$router.push({ name: 'group-perm-oper', params: {id: this.selectedItemKeys }});
    // },
    async loadPageData(refresh = false) {
      this.loading = true;
      try {
        await this.$store.dispatch("groups/loadGroups");
        this.groups = this.$store.getters["groups/getGroups"];
      } catch (error) {
        this.error = error.message || "Unexpected Error.";
      } finally {
        this.loading = false;
      }
    },
    onExporting(e) {
      e.fileName = `GroupsDataExport_${new Date().toISOString().slice(0, 10)}`;
    }
  },
};
</script>

<style scoped>
.list-icon {
  margin: 0px 10px 0px 0px;
}
</style>
